angular.module('lf.common')

.directive('scrollToBlockOnError', function () {
  return function (scope, el) {
    var client = lf.data.xhr.client;
    var scrollable;

    if (client.isDesktop) {
      var scrollOpts = {
        duration: 600,
        offset: -300
      };

      var node = el[0];
      
      do {
        var overflowY = $(node).css('overflow-y');
        if ((overflowY === 'auto' || overflowY === 'scroll')
            && (node.scrollHeight > node.clientHeight)) {
          scrollable = node;
          break;
        }
      } while ((node = node.parentNode) && node !== document.body);
      
      if (scrollable) {
        $.extend(scrollOpts, {
          duration: 300,
          container: scrollable
        });
      }
      
      el.velocity('scroll', scrollOpts);

    } else if (client.isMobile) {
      scrollable = el.closest('[scrollable], .slidein-container.scrollable');
      var iscroll = scrollable.length && scrollable.data('iscroll');
      if (iscroll) {
        iscroll.scrollToElement(el[0], 300, 0, true);
      }
    }
    
  }
});
